
/*
*
* author chenlong
* 手机样式预览  弹框
*
*/
import { Loading } from 'element-ui'
import { Component, Prop, Vue, Watch, } from "vue-property-decorator";
import { UpdateProductDto, ProductService, ProductCategoryService, UpdateProductMoreFileDto, CreateOrUpdateProductSpecificationDto } from "@/api/service-proxies";

@Component({
  name: "PriVewDialog",
})
export default class extends Vue {
  product: UpdateProductDto = new UpdateProductDto();
  productService: ProductService = new ProductService();
  //商品分类
  productCategoryService: ProductCategoryService = new ProductCategoryService();
  productCategoryType: any = [];
  img = 'http://file6.wkxiaolvsan.com/files/2XMT7leHrfHTWVD83bpxiCgLh62O~AANASgADWhGwzXNfiUx7bKF9Mi6I3HGZc9g07Q?auth=wkxiaolvsan'
  swiperList = [
    {
      id: 0,
      type: "image",
      url: "http://file6.wkxiaolvsan.com/files/2~SCeMd~bFag1oXjQyxXsawLD13azAALgIwAC-EmwzXNfiUxxzieD9NWI3Gf6-d7rtQ?auth=wkxiaolvsan",
    },
    {
      id: 1,
      type: "image",
      url: "http://file6.wkxiaolvsan.com/files/2CLBJV4iZHux1D4DHPVuq7wJbxb-CAALdNQAC-R-wzXNfiUxxziedgEeI3Gf6-fhnXA?auth=wkxiaolvsan",
    },
    {
      id: 2,
      type: "image",
      url: "http://file6.wkxiaolvsan.com/files/2zaxtpmXfQtKmupauJm0srALegJZ1AALoywAC~eqwzXNfiUxxzifVVHWI3Gf6-jAN3A?auth=wkxiaolvsan",
    },
    {
      id: 3,
      type: "image",
      url: "http://file6.wkxiaolvsan.com/files/2kqeoJH3LjCZQKV04tp0XsQI9oM3uAALjUAAC726wzXNfiUxxzigkGAWI3Gf6-n7V7g?auth=wkxiaolvsan",
    },
  ];
  form = { name: '' }
  dialogTableVisible = false
  public open(id: number) {

    this.dialogTableVisible = true
    this.getProduct(id);

  }

  async getProduct(id: number) {

        let product = await this.productService.get(id);
        this.product = <UpdateProductDto>product;
        this.product.p_Path = (this as any).$aes.imgAddAuth(this.product.p_Path)
        this.product.imageList.forEach(e=>{
          e.p_Path = (this as any).$aes.imgAddAuth(e.p_Path)
        })
       // this.inputValue2 = this.product.describe

    }
  // 关闭弹框
  hideModal() {
    // document.body.style.height = '100vh'
    // document.body.style['overflow-y'] = 'hidden';
    this.dialogTableVisible = false
  }

}
